"use client";

import type { ReactNode } from "react";

/** Where the Google button goes, with the zone this browser is in (#249). */
export const GOOGLE_START = "/api/auth/google/start";

export function googleHref(tz: string | null | undefined): string {
  return tz ? `${GOOGLE_START}?tz=${encodeURIComponent(tz)}` : GOOGLE_START;
}

/**
 * The Google button's link. A new account made through Google is counted in
 * the days of the zone its browser is in — the sign-up form sends the same
 * thing (Forms.tsx) — and the server cannot see the zone, so the link says it
 * when it is pressed. Pressed, not drawn: the page is rendered on the server,
 * which knows no browser's zone. Without script the plain link still works and
 * the account starts in Berlin's days, which settings can change.
 */
export function GoogleLink({ label, children }: { label: string; children: ReactNode }) {
  return (
    <a
      className="oauth-icon"
      href={GOOGLE_START}
      aria-label={label}
      title={label}
      onClick={(e) => {
        let tz: string | undefined;
        try {
          tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch {
          tz = undefined;
        }
        e.currentTarget.href = googleHref(tz);
      }}
    >
      {children}
    </a>
  );
}
